// extracted by mini-css-extract-plugin
module.exports = {"root":"elements-portfolio_root__CfrCM"};